<style lang="scss" scoped>
.fake-input {
  pointer-events: none;
  border: solid 1px lightgrey;
  border-right: 0;
  text-indent: 5px;
  max-width: 185px;
}

.red {
  color: red;
}
</style>
<template>
  <!-- eslint-disable max-len -->
  <div class="container">
    <div v-if="!loading" class="theme-color-wrapper p-2 booking-slots-page">
      <div class="calls row">
        <section class="col-12">
          <h2 cy="page-title" class="font-weight-boldererer mb-2">Update Booking Slot</h2>
          <router-link :to="{ name: 'social-booking-slots'}" class="body-text">
            &laquo; Back to booking slots
          </router-link>
        </section>
      </div>

      <div class="row my-2">
        <div class="slot-stage-wrapper">
          <div class="col-12">

            <section class="pb-2">
              <h4 class="pb-1">Is the slot for a specific location?</h4>
              <p>If so, this slot will only be visible for a specific location</p>
              <b-form-select
                id="visit-locations"
                v-model="visitLocationId"
                class="mb-1"
                :disabled="visitLocations.length <= 0 || loading"
              >
                <b-form-select-option value="">
                  All Locations
                </b-form-select-option>
                <b-form-select-option v-for="item in visitLocations" :key="item._id" :value="item._id">
                  {{ item.name }}
                </b-form-select-option>
              </b-form-select>
            </section>

            <section class="slot-stage">
              <h4 class="pb-1">When should the slot start?</h4>
              <div class="clock-custom d-flex" style="font-size: 18pt" cy="start-time">
                <div>
                  <i class="fas fa-chevron-up d-block"
                     @click="increaseTimeSlot('slotBeginHour', hours, updateEndSlot)"
                  />
                  <span class="d-block">{{ slotBeginHour }} :</span>
                  <i class="fas fa-chevron-down d-block"
                     @click="decreaseTimeSlot('slotBeginHour', hours, updateEndSlot)"
                  />
                </div>

                <div class="ml-1">
                  <i class="fas fa-chevron-up d-block"
                     @click="increaseTimeSlot('slotBeginMin', mins, updateEndSlot)"
                  />
                  <span class="d-block">{{ slotBeginMin }}</span>
                  <i class="fas fa-chevron-down d-block"
                     @click="decreaseTimeSlot('slotBeginMin', mins, updateEndSlot)"
                  />
                </div>
              </div>

              <p class="pb-2 mt-2 font-weight-bolder">
                This slot will start at: <b>{{ slotBeginHour }}:{{ slotBeginMin }}</b>
              </p>
            </section>

            <section class="slot-stage">
              <h4 class="pb-2">When should the slot end?</h4>

              <b-alert v-if="!endDateValid" show variant="danger" class="font-weight-bolder p-2">
                <i class="fas fa-exclamation-triangle mr-2"></i>Please ensure the end time is after the start time.
              </b-alert>

              <div class="clock-custom d-flex" style="font-size: 18pt" cy="end-time">
                <div>
                  <i class="fas fa-chevron-up d-block"
                     @click="increaseTimeSlot('slotEndHour', hours, checkEndSlotValid)"
                  />
                  <span class="d-block">{{ slotEndHour }} :</span>
                  <i class="fas fa-chevron-down d-block"
                     @click="decreaseTimeSlot('slotEndHour', hours, checkEndSlotValid)"
                  />
                </div>

                <div class="ml-1">
                  <i class="fas fa-chevron-up d-block"
                     @click="increaseTimeSlot('slotEndMin', mins, checkEndSlotValid)"
                  />
                  <span class="d-block">{{ slotEndMin }}</span>
                  <i class="fas fa-chevron-down d-block"
                     @click="decreaseTimeSlot('slotEndMin', mins, checkEndSlotValid)"
                  />
                </div>
              </div>

              <p class="pb-2 mt-2 font-weight-bolder" cy="slot-text">
                This slot will start at: <b>{{ slotBeginHour }}:{{ slotBeginMin }}</b>
                <span class="px-1 d-inline-block">and end at: <b>{{ slotEndHour }}:{{ slotEndMin }}</b></span>
              </p>
            </section>

            <section class="slot-stage">
              <h4 class="pb-2 font-weight-bolder">Add a slot description</h4>

              <!--            <div class="form-group full-width d-flex">-->
              <!--              <input class="fake-input" v-model="bookingSlotName" type="text">-->
              <!--              <input-->
              <!--                style="border-left: 0"-->
              <!--                class="form-control"-->
              <!--                type="text"-->
              <!--                placeholder="Slot description"-->
              <!--                v-model="bookingSlotDescription"-->
              <!--              >-->
              <!--            </div> -->

              <div class="form-group full-width d-flex">
                <input v-model="bookingSlotName"
                       cy="slot-name"
                       style="border-left: 0"
                       class="form-control"
                       type="text"
                       placeholder="Slot description"
                >
              </div>
            </section>

            <section class="slot-stage">
              <h4 class="pt-2">Do you want to apply a table count?</h4>
              <p>This amount will be used instead of the main table count.</p>
              <b-form-checkbox v-model="applyTableCount" name="check-button" switch>
                Apply table count
              </b-form-checkbox>
              <section v-if="applyTableCount">
                <b-form-input
                  v-model="socialTableCount"
                  number
                  placeholder="Enter a new maximum table count"
                  value=""
                />
              </section>
            </section>

            <section class="slot-stage">
              <h4 class="pb-2 pt-2">Do you want to apply a date range?</h4>

              <b-form-checkbox v-model="applyDateRange" name="check-button" switch @change="resetStartEndDate()">
                Apply date range
              </b-form-checkbox>

              <section v-if="applyDateRange">
                <p class="pt-3">Select a start and end date</p>
                <div>
                  <label>Start Date</label>
                  <b-form-datepicker
                    v-model="start_date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                    @input="end_date = ''"
                  />
                  <label>End Date</label>
                  <b-form-datepicker
                    v-model="end_date"
                    :min="start_date"
                    :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                  />
                </div>
              </section>

            </section>

            <section class="slot-stage">
              <button :class="{'disabled': !endDateValid}" class="btn btn-block btn-success mt-2"
                      @click="displayBookingSlotInfoModal()"
              >
                Change booking slot (This will make the slot available for bookings)
              </button>
            </section>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p>Loading...</p>
    </div>
  </div>
  <!-- eslint-enable -->
</template>

<script>
import moment from 'moment';
import SocialBookingSlotService from '@/services/SocialBookingSlotsService';
import { mapState } from 'vuex';
import { ERROR_CODES } from '@/util/errorCodes';
import VisitLocationsService from '@/services/VisitLocationsService';

export default {
  name: 'UpdateBookingSlot',
  data() {
    return {
      bookingSlotId: '',
      loading: true,
      // bookingSlotDescription: '',
      bookingSlot: null,
      bookingSlotActive: null,
      bookingSlotName: '',
      slotBeginHour: '',
      slotBeginMin: '',
      slotEndHour: '',
      slotEndMin: '',
      start_date: '',
      end_date: '',
      weekDays: SocialBookingSlotService.getWeekdays(),
      hours: SocialBookingSlotService.getHours(),
      mins: SocialBookingSlotService.getMinutes(),
      endDateValid: true,
      applyDateRange: false,
      applyTableCount: false,
      socialTableCount: null,
      visitLocations: [],
      visitLocationId: '',
    };
  },
  computed: mapState({
    prison: state => state.prison.prison,
    allBookingSlots: state => state.socialBookingSlots.bookingSlots,
  }),
  async mounted() {
    await this.$store.dispatch('prison/getPrison');
    this.bookingSlotId = this.$route.params.bookingSlotId;
    await this.getVisitLocations();
    this.getBookingSlot();
    await this.$store.dispatch('socialBookingSlots/getBookingSlots');
  },
  methods: {
    async getVisitLocations() {
      try {
        const response = await VisitLocationsService.getVisitLocationsForPrison();
        this.visitLocations = response.data;
      } catch (e) {
        console.error('Error getting visit locations');
        this.$toast.error('Error getting visit locations', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      }
    },
    getBookingSlot() {
      SocialBookingSlotService.getBookingSlotSingle(this.bookingSlotId).then(res => {
        this.bookingSlot = res.data;
        //  const name = this.bookingSlot.name.split('|');

        // this.bookingSlotName = name[1] ? name[0] + '|' : name[0];
        // console.log(name, 'slot', this.bookingSlot.name);
        // if(name[1]){
        //   this.bookingSlotDescription = name[1];
        // }

        this.bookingSlotName = this.bookingSlot.name;
        this.bookingSlotActive = this.bookingSlot.active ? 'active' : 'inActive';
        this.slotBeginHour = this.bookingSlot.slot_begin.split(':')[0];
        this.slotBeginMin = this.bookingSlot.slot_begin.split(':')[1];
        this.slotEndHour = this.bookingSlot.slot_end.split(':')[0];
        this.slotEndMin = this.bookingSlot.slot_end.split(':')[1];
        this.start_date = this.bookingSlot.start_date ? moment(this.bookingSlot.start_date).format('YYYY-MM-DD') : '';
        this.end_date = this.bookingSlot.end_date ? moment(this.bookingSlot.end_date).format('YYYY-MM-DD') : '';
        this.visitLocationId = this.bookingSlot.visit_location ? this.bookingSlot.visit_location.visit_location_id : '';
        this.socialTableCount = this.bookingSlot.social_table_count;
        this.applyTableCount = this.bookingSlot.social_table_count !== null;

        if (this.start_date) {
          this.applyDateRange = true;
        }

        this.loading = false;
      }).catch(err => {
        console.log('Error getting booking slot ', err);
        this.$toast.error('Error getting the booking slot', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
        this.$router.go(-1);
      });
    },
    validUpdate() {
      return this.bookingSlotName && this.bookingSlotName.length > 0;
    },
    displayBookingSlotInfoModal() {
      this.$swal({
        title: 'Existing bookings will not be changed',
        text: 'This change is only valid for new bookings. Existing bookings must be honoured in their original time.',
        icon: 'info',
        buttons: true,
      }).then(value => {
        if (value) {
          this.checkDuplicateBookingSlots();
        }
      });
    },
    checkDuplicateBookingSlots() {
      let duplicateSlots = [];

      // Loop through selected days to get duplicated slots and create new ones
      const slotBegin = `${this.slotBeginHour}:${this.slotBeginMin}`;
      const slotEnd = `${this.slotEndHour}:${this.slotEndMin}`;

      duplicateSlots = SocialBookingSlotService.getDuplicatedDates(
        this.allBookingSlots,
        this.bookingSlot.day_of_week,
        slotBegin,
        slotEnd,
        this.bookingSlot._id,
        this.bookingSlot.visit_location ? this.bookingSlot.visit_location.visit_location_id : null,
      );
      duplicateSlots = SocialBookingSlotService.filterDuplicatesByDateRange(duplicateSlots, {
        start_date: this.start_date,
        end_date: this.end_date,
      });
      if (duplicateSlots[0]) { // warn if duplicates, otherwise create
        this.displayBookingSlotOverlapModal(duplicateSlots[0], duplicateSlots);
      } else {
        this.updateBookingSlot();
      }
    },
    displayBookingSlotOverlapModal(slot, slots) {
      const name = SocialBookingSlotService.getOverlapName(slot);

      this.$swal({
        title: `This overlaps with an existing slot ${name}`,
        text: 'Do you want to overwrite the existing slot?',
        icon: 'warning',
        buttons: true,
      }).then(value => {
        if (value) { // if yes update slot
          // delete overlap
          const slotClone = { ...slot };
          slotClone.active = false;
          SocialBookingSlotService.updateBookingSlot(slotClone._id, slotClone).then(() => {
            this.manageUpdatingSlots(slot, slots);
          }).catch(err => {
            console.log('Error deleting booking slot ', err);
            // eslint-disable-next-line max-len
            if (err && err.response && err.response.data && err.response.data.error === ERROR_CODES.BOOKING_SLOTS.OVERLAP) {
              this.$toast.error('Error deleting the booking slot, booking slot overlaps', {
                toastClassName: ['toast-std', 'warning-toast'],
              });
            } else {
              this.$toast.error('Error deleting the booking slot', {
                toastClassName: ['toast-std', 'warning-toast'],
              });
            }
          });
        } else {
          this.$toast.info('Booking slot not updated');
          this.$router.push({ name: 'social-booking-slots' });
        }
      });
    },
    manageUpdatingSlots(slot, slots) {
      const newSlots = slots.splice(1); // remove the first slot

      if (newSlots[0]) {
        this.displayBookingSlotOverlapModal(newSlots[0], newSlots);
      } else { // finished update all slots
        this.updateBookingSlot();
      }
    },
    updateBookingSlot() {
      if (this.validUpdate()) {
        this.$toast.info('Updating booking slot...');

        const updateDto = {
          // name: this.bookingSlotDescription ? this.bookingSlotName + '-' + this.bookingSlotDescription : this.bookingSlotName,
          name: this.bookingSlotName,
          active: this.bookingSlotActive === 'active',
          slot_begin: `${this.slotBeginHour}:${this.slotBeginMin}`,
          slot_end: `${this.slotEndHour}:${this.slotEndMin}`,
          start_date: this.start_date,
          end_date: this.end_date,
          visit_location_id: this.visitLocationId,
          social_table_count: this.applyTableCount ? this.socialTableCount : null,
        };

        SocialBookingSlotService.updateBookingSlot(this.bookingSlotId, updateDto).then(() => {
          this.$toast.success('Booking slot successfully updated', {
            toastClassName: ['toast-std', 'success-toast'],
          });
          this.$router.push({ name: 'social-booking-slots' });
        }).catch(err => {
          console.log('Error updating booking slot ', err.response);
          // eslint-disable-next-line max-len
          if (err && err.response && err.response.data && err.response.data.error === ERROR_CODES.BOOKING_SLOTS.OVERLAP) {
            // this.displayBookingSlotOverlapModal();
            console.log('overlap');
          } else {
            this.$toast.error('Error updating the booking slot', {
              toastClassName: ['toast-std', 'warning-toast'],
            });
          }
        });
      } else {
        this.$toast.info('Please check you have entered a name for the booking slot');
      }
    },
    updateEndSlot() {
      this.checkEndSlotValid();
    },
    checkEndSlotValid() {
      let startTime = `${this.slotBeginHour}:${this.slotBeginMin}:00`;
      let endTime = `${this.slotEndHour}:${this.slotEndMin}:00`;

      startTime = moment(startTime, 'HH:mm:ss');
      endTime = moment(endTime, 'HH:mm:ss');

      const duration = moment.duration(endTime.diff(startTime));
      const minutesLeft = duration.asMinutes();

      const negative = Math.sign(minutesLeft) === -1;

      this.endDateValid = !negative;
    },
    increaseTimeSlot(prop, array, callback) {
      const value = this[prop];
      const max = array.length - 1;
      const index = array.indexOf(value);

      if (index < max) {
        this[prop] = array[index + 1]; // first element
      } else {
        this[prop] = array[0];
      }

      if (callback) {
        callback();
      }
    },
    decreaseTimeSlot(prop, array, callback) {
      const value = this[prop];
      const max = array.length - 1;
      const index = array.indexOf(value);

      if (index === 0) {
        this[prop] = array[max]; // first element
      } else {
        this[prop] = array[index - 1];
      }

      if (callback) {
        callback();
      }
    },
    resetStartEndDate() {
      this.start_date = '';
      this.end_date = '';
    },
  },
};
</script>
